import { Sparkles, User, MapPin, Briefcase, CreditCard, Shield, FileText, Check } from 'lucide-react';

/**
 * Role options shown on the Welcome step of the onboarding wizard.
 */
export const ROLE_OPTIONS = [
  {
    id: 'client',
    title: 'I Need Help',
    subtitle: 'Post tasks and hire heroes',
    icon: '📋',
    features: ['Post unlimited tasks', 'Browse verified heroes', 'Secure payments'],
  },
  {
    id: 'hero',
    title: 'I Want to Help',
    subtitle: 'Earn money completing tasks',
    icon: '🦸',
    features: ['Browse jobs near you', 'Set your own rates', 'Get paid fast'],
  },
  {
    id: 'both',
    title: 'Both',
    subtitle: 'Post tasks and earn money',
    icon: '⚡',
    features: ['Full access to all features', 'Switch modes anytime', 'Maximum flexibility'],
  },
];

/**
 * Calculate whole-year age from an ISO date-of-birth string.
 */
export const calculateAge = (dob) => {
  if (!dob) return null;
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

/**
 * Build the ordered list of wizard steps, conditionally including the
 * hero-only Skills + Bank Payouts steps.
 */
export const buildSteps = ({ showHeroSteps }) => {
  const steps = [
    { id: 1, title: 'Welcome', icon: Sparkles },
    { id: 2, title: 'Basic Info', icon: User },
    { id: 3, title: 'Location', icon: MapPin },
  ];
  let stepId = 4;
  if (showHeroSteps) {
    steps.push({ id: stepId++, title: 'Skills', icon: Briefcase });
    steps.push({ id: stepId++, title: 'Bank Payouts', icon: CreditCard });
  }
  steps.push({ id: stepId++, title: 'Verify ID', icon: Shield });
  steps.push({ id: stepId++, title: 'Terms', icon: FileText });
  steps.push({ id: stepId++, title: 'Complete', icon: Check });
  return steps;
};

/**
 * Map a 1-based step number to the step type string (`welcome`, `basic_info`,
 * `location`, `skills`, `payouts`, `verify_id`, `terms`, `complete`).
 */
export const getStepType = (stepNum, steps) => {
  if (stepNum === 1) return 'welcome';
  if (stepNum === 2) return 'basic_info';
  if (stepNum === 3) return 'location';

  const stepsAfterLocation = steps.slice(3);
  const currentStepData = stepsAfterLocation[stepNum - 4];

  if (currentStepData?.title === 'Skills') return 'skills';
  if (currentStepData?.title === 'Bank Payouts') return 'payouts';
  if (currentStepData?.title === 'Verify ID') return 'verify_id';
  if (currentStepData?.title === 'Terms') return 'terms';
  if (currentStepData?.title === 'Complete') return 'complete';

  return 'unknown';
};
